import React from 'react';
import { Settings as SettingsComponent } from '../components/Settings';

const Settings: React.FC = () => {
  return <SettingsComponent />;
};

export default Settings; 